import React from "react";
import { MdEmail, MdFileDownload } from "react-icons/md";
import { TableBodyStyle } from "../../styles/globalStyles";
import useUserData from "../../hooks/useUserData";
import { REPORT_TYPE } from "../../api/Constants";
import { downloadReport, emailReport } from "../../api/RestCallHelper";
import {
  FeedbackReducerActionType,
  useFeedbackDispatch,
} from "../../utils/FeedbackContext";
import { useHistory, useLocation } from "react-router-dom";
import {
  ReportsWrapper,
  StyledTableWrapper,
  StyledTable,
  HeaderCell,
  StyledRow,
  ReportsButton,
} from "./ReportsScreenStyles";

export default function ReportsScreen() {
  let location = useLocation();
  let history = useHistory();

  const user = useUserData();
  const dispatch = useFeedbackDispatch();

  const closeSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({ type: FeedbackReducerActionType.CLOSE_FEEDBACK });
  };

  return (
    <ReportsWrapper>
      <StyledTableWrapper>
        <StyledTable>
          <thead>
            <tr>
              <HeaderCell bg="lightgray">Reports</HeaderCell>
              <HeaderCell bg="var(--c5)">Download</HeaderCell>
              <HeaderCell bg="var(--c4)">Email</HeaderCell>
            </tr>
          </thead>
          <tbody>
            <StyledRow>
              <td>
                <TableBodyStyle>Claim Dump</TableBodyStyle>
              </td>
              <td>
                <ReportsButton
                  color="var(--c5)"
                  onClick={() =>
                    downloadReport(
                      REPORT_TYPE.CLAIMS,
                      dispatch,
                      closeSnack,
                      history,
                      location
                    )
                  }
                >
                  <MdFileDownload />
                </ReportsButton>
              </td>
              <td>
                <ReportsButton
                  color="var(--c4)"
                  onClick={() =>
                    emailReport(
                      REPORT_TYPE.CLAIMS,
                      user.email,
                      dispatch,
                      closeSnack,
                      history,
                      location
                    )
                  }
                >
                  <MdEmail />
                </ReportsButton>
              </td>
            </StyledRow>

            <StyledRow>
              <td>
                <TableBodyStyle>Member Details</TableBodyStyle>
              </td>
              <td>
                <ReportsButton
                  color="var(--c5)"
                  onClick={() =>
                    downloadReport(
                      REPORT_TYPE.MEMBER_DETAILS,
                      dispatch,
                      closeSnack,
                      history,
                      location
                    )
                  }
                >
                  <MdFileDownload />
                </ReportsButton>
              </td>
              <td>
                <ReportsButton
                  color="var(--c4)"
                  onClick={() =>
                    emailReport(
                      REPORT_TYPE.MEMBER_DETAILS,
                      user.email,
                      dispatch,
                      closeSnack,
                      history,
                      location
                    )
                  }
                >
                  <MdEmail />
                </ReportsButton>
              </td>
            </StyledRow>
          </tbody>
        </StyledTable>
      </StyledTableWrapper>
    </ReportsWrapper>
  );
}
